module.exports = __webpack_public_path__ + "img/20220930164223.d5b9832a.png";